/**
 * Подписи режимов — обеих осей, одним словарём.
 *
 * Один словарь, потому что мест ДВА: экран «Режим работы» и шапка диалога.
 * До 10.09 подписи оси доставки жили только на экране, а бейдж в диалоге
 * собирал их своим тернарником — то есть одно знание уже было в двух местах.
 * Третье место (переключатель генерации в диалоге) закрепило бы расхождение:
 * экран сказал бы «Только в начатых беседах», диалог — что-нибудь своё.
 *
 * ЧЕГО ЗДЕСЬ НЕТ НАМЕРЕННО: слов «защита от посторонних» и «отсечёт спам» у
 * режима `known`. Адрес отправителя письма в этом проекте ничем не
 * подтверждён (проверок DKIM/SPF нет), и обещать защиту значило бы обещать
 * то, чего нет. Правило описано поведением: «там, где мы уже отвечали».
 */

import type { AutoReplyMode, GenerationMode } from '../api/auto-reply';
import type { InboxItem } from '../api/inbox';

export interface ModeInfo {
  readonly label: string;
  readonly description: string;
  readonly icon: string;
}

/** Ось ДОСТАВКИ: что делать с готовым черновиком. */
export const AUTO_REPLY_MODE_INFO: Record<AutoReplyMode, ModeInfo> = {
  shadow: {
    label: 'Shadow',
    description: 'AI пишет черновик, вы проверяете и отправляете.',
    icon: '👁',
  },
  bot: {
    label: 'Бот',
    description: 'AI отвечает как бот по KB. Спорное передаёт вам.',
    icon: '🤖',
  },
  assistant: {
    label: 'Ассистент',
    description: 'AI отвечает от лица команды. Клиент не отличит от человека.',
    icon: '🧑‍💼',
  },
};

/** Ось ГЕНЕРАЦИИ: браться ли за черновик вообще. */
export const GENERATION_MODE_INFO: Record<GenerationMode, ModeInfo> = {
  always: {
    label: 'Готовить всегда',
    description: 'Черновик на каждое входящее сообщение — в почте, телеграме и виджете.',
    icon: '✍️',
  },
  known: {
    label: 'Только в начатых беседах',
    description:
      'Черновик готовится там, где мы этому человеку уже отвечали. В остальных диалогах — по кнопке «Подготовить ответ».',
    icon: '🤝',
  },
  manual: {
    label: 'Только по кнопке',
    description: 'Сам не готовит ничего. Черновик появляется, когда вы нажмёте «Подготовить ответ».',
    icon: '🖐',
  },
};

/** Названия каналов для разбивки прогноза. */
export const CHANNEL_LABELS: Record<InboxItem['channel'], string> = {
  email: 'Почта',
  telegram: 'Телеграм',
  widget: 'Виджет',
};
